import React from 'react';
import MediaQuery from 'react-responsive';
import { Link, Text } from 'pp-react';

import content from '../lib/i18n';
const i18n = content('multiCharityFundraiser/components/SimpleHeader');

const HeaderStyle = {
  position: 'absolute',
  width: '100%',
  height: '72px',
  zIndex: '10',
};

const HeaderBorderStyle = {};

const HeaderContainerStyle = {
  maxWidth: '1024px',
  margin: 'auto',
  position: 'relative',
};

const LogoBackground = {
  white: {
    background:
      'transparent url(https://www.paypalobjects.com/webstatic/i/logo/rebrand/ppcom-white.svg) center center no-repeat',
  },
  blue: {
    background:
      'transparent url(https://www.paypalobjects.com/webstatic/i/logo/rebrand/ppcom.svg) center center no-repeat',
  },
};

const BigLogoStyle = {
  background:
    'transparent url(https://www.paypalobjects.com/webstatic/i/logo/rebrand/ppcom-white.svg) center center no-repeat',
  backgroundSize: '124px 33px',
  position: 'absolute',
  top: '10px',
  width: '136px',
  height: '43px',
  textIndent: '-9999px',
};

const SmallLogoStyle = {
  background:
    'transparent url(https://www.paypalobjects.com/webstatic/i/logo/rebrand/ppcom-white.svg) center center no-repeat',
  backgroundSize: '124px 33px',
  position: 'absolute',
  top: '10px',
  width: '35px',
  height: '50px',
  overflow: 'hidden',
  textIndent: '-9999px',
  backgroundPosition: '8px',
};

const SimpleHeader = ({
  hasBorder = true,
  logoColor = 'white',
  hasHomeLink = false,
  allCharityCampaign = false,
  ...props
}) => {
  const FinalHeaderStyle = hasBorder ?
    Object.assign({}, HeaderStyle, HeaderBorderStyle) :
    Object.assign({}, HeaderStyle);
  let homeLink;
  if (hasHomeLink === true) {
    // TODO read the link from locale or from passing-down prop
    let color = { color: 'white' };
    if (logoColor === 'blue') {
      color = { color: '#0070BA' };
    }
    homeLink = (
      <Link
        href={props.homeLink}
        style={Object.assign(
          {},
          {
            position: 'absolute',
            top: '14px',
            right: '30px',
            textDecoration: 'none',
          },
          color
        )}
      >
        <Text as='h5' size='sm' regular>
          {i18n('label.home-link')}
        </Text>
      </Link>
    );
  }

  return (
    <header style={FinalHeaderStyle}>
      <div
        style={
          allCharityCampaign ?
            Object.assign({ HeaderContainerStyle }, { marginLeft: '24px' }) :
            HeaderContainerStyle
        }
      >
        <MediaQuery minWidth={481}>
          <a
            id={'headerLogo'}
            href={'https://www.paypal.com'}
            style={Object.assign({}, BigLogoStyle, LogoBackground[logoColor])}
          >
            PayPal
          </a>
        </MediaQuery>
        <MediaQuery maxWidth={480}>
          <a
            id={'headerLogo'}
            href={'https://www.paypal.com'}
            style={Object.assign({}, SmallLogoStyle, LogoBackground[logoColor])}
          >
            PayPal
          </a>
        </MediaQuery>
        {homeLink}
      </div>
    </header>
  );
};

export default SimpleHeader;
